<div class="clr-row">
    <div class="clr-col-6">
        <div class="card">
            <h3 class="card-header" style="margin-top: 0px;">Installation status</h3>
            <div class="card-text">
                <clr-timeline [clrLayout]="ClrTimelineLayout.VERTICAL" style="width: 100%">
                    <clr-timeline-step [clrState]="statuses.step1">
                        <clr-timeline-step-header>Step 1</clr-timeline-step-header>
                        <clr-timeline-step-title>Deploy the DC Netscope VM</clr-timeline-step-title>
                        <clr-timeline-step-description>DC Netscope requires a second VM to installed besides the DC Scope VM.
                            <br/>
                            You have to download the OVA file for DC Netscope (<a target="_blank" href="https://www.easyvirt.com/en/download/">here</a>) and deploy it on your infrastructure.
                            <br/>
                            <br/>
                            You will find more information on the installation process here at the following URL:
                            <br/>
                            <a target="_blank" href="https://www.easyvirt.com/dc-netscope-network-monitoring-tool/installation-dc-netscope">https://www.easyvirt.com/dc-netscope-network-monitoring-tool/installation-dc-netscope</a>
                        </clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step [clrState]="statuses.step2">
                        <clr-timeline-step-header>Step 2</clr-timeline-step-header>
                        <clr-timeline-step-title>Initialize DC Netscope</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Use the VMware console of the DC Netscope VM to configure DC Netscope.
                            <br/>
                            You will have to do the following:
                            <ul>
                                <li>Choose a password</li>
                                <li>Configure the connection to a vCenter
                                    <span *ngFor="let vcenter of vcenters" class="label {{ vcenter.cssClass }}">
                                        {{ vcenter.name }}
                                        <span class="badge">{{ vcenter.status }}</span>
                                    </span>
                                </li>
                            </ul>
                            <br/>
                            You will find more information on the initialization process here at the following URL:
                            <br/>
                            <a target="_blank" href="https://www.easyvirt.com/dc-netscope-network-monitoring-tool/installation-dc-netscope">https://www.easyvirt.com/dc-netscope-network-monitoring-tool/installation-dc-netscope</a>

                        </clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step class="gemini-ignore" [clrState]="statuses.step3">
                        <clr-timeline-step-header>Step 3</clr-timeline-step-header>
                        <clr-timeline-step-title>Add the DC Netscope agent's URL in DC Scope's settings</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Ensure that the URL to the DC Netscope agent is added in DC Scope's settings. To do so, do the following:
                            <ul>
                                <li>Go in DC Scope settings</li>
                                <li>Go to the DC Netscope tab</li>
                                <li>Add the URL to the DC Netscope agent. The URL is displayed in the console of the DC Netscope VM.
                                    It is usually in the form of
                                    <code>http://ip_address:5000</code> or <code>https://ip_address:5443</code></li>
                                <li>Press enter to confirm</li>
                            </ul>

                            <span *ngIf="canConnectToDcnetscope" class="label label-success">
                                DC Scope can connect to DC Netscope
                            </span>
                            <span *ngIf="this.urlDcNetscopeAgent !== undefined && !canConnectToDcnetscope" class="label label-danger">
                                DC Scope cannot connect to DC Netscope ({{ this.urlDcNetscopeAgent }})
                            </span>
                        </clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step [clrState]="statuses.step4">
                        <clr-timeline-step-header>Step 4</clr-timeline-step-header>
                        <clr-timeline-step-title>Configure the Distributed vSwitches</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Configuration of Distributed vSwitches is made in two steps:
                            <ol>
                                <li>Configure the URL to the DC Netscope exporter in the Netflow parameters of the Distributed vSwitches. The URL is usually in the form of
                                    <code>http://ip_address:9000</code></li>
                                <li>Enable Netflow in the settings of Portgroups of the Distributed vSwitches.</li>
                            </ol>
                            <br/>
                            <br/>
                            You will find more information on the initialization process here at the following URL:
                            <br/>
                            <a target="_blank" href="https://www.easyvirt.com/dc-netscope-network-monitoring-tool/installation-dc-netscope">https://www.easyvirt.com/dc-netscope-network-monitoring-tool/installation-dc-netscope</a>
                        </clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step [clrState]="statuses.collect_status">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>Collect is working</clr-timeline-step-title>
                        <clr-timeline-step-description>Distributed vSwitches are exporting netflow data to DC Netscope.</clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step [clrState]="statuses.operation_status">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>DC Netscope is operational</clr-timeline-step-title>
                        <clr-timeline-step-description>DC Netscope is configured and is collecting flows information from Distributed vSwitches.</clr-timeline-step-description>
                    </clr-timeline-step>
                </clr-timeline>
            </div>
        </div>
    </div>

    <div class="clr-col-6">
        <div class="card">
            <h3 class="card-header" style="margin-top: 0px;">Endpoint status</h3>
            <div class="card-text">
                <clr-timeline [clrLayout]="ClrTimelineLayout.VERTICAL" style="width: 100%">
                    <clr-timeline-step [clrState]="endpointStatuses.lastInfrastructure">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>Recent infrastructure description</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Check that DC Netscope has a recent description of the infrastructure.
                        </clr-timeline-step-description>
                    </clr-timeline-step>
<!--                    <clr-timeline-step [clrState]="endpointStatuses.dashboard">-->
<!--                        <clr-timeline-step-header></clr-timeline-step-header>-->
<!--                        <clr-timeline-step-title>Dashboard endpoint</clr-timeline-step-title>-->
<!--                        <clr-timeline-step-description>-->
<!--                            Check that data for the dashboard component is available.-->
<!--                        </clr-timeline-step-description>-->
<!--                    </clr-timeline-step>-->
                    <clr-timeline-step [clrState]="endpointStatuses.collectHistory">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>Collect history</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Check that data for the dashboard's collect history graph is available.
                        </clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step [clrState]="endpointStatuses.topology">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>Topology</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Check that data for topology component is available.
                        </clr-timeline-step-description>
                    </clr-timeline-step>
<!--                    <clr-timeline-step [clrState]="endpointStatuses.flows">-->
<!--                        <clr-timeline-step-header></clr-timeline-step-header>-->
<!--                        <clr-timeline-step-title>Flows data</clr-timeline-step-title>-->
<!--                        <clr-timeline-step-description>-->
<!--                            Check that data for flows visualizations is available.-->
<!--                        </clr-timeline-step-description>-->
<!--                    </clr-timeline-step>-->
                    <clr-timeline-step [clrState]="endpointStatuses.appsGroups">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>App groups</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Check that data for app groups visualizations is available.
                        </clr-timeline-step-description>
                    </clr-timeline-step>
                    <clr-timeline-step [clrState]="endpointStatuses.externalIps">
                        <clr-timeline-step-header></clr-timeline-step-header>
                        <clr-timeline-step-title>External IPs</clr-timeline-step-title>
                        <clr-timeline-step-description>
                            Check that data for External IPs is available.
                        </clr-timeline-step-description>
                    </clr-timeline-step>
                </clr-timeline>
            </div>
        </div>

        <div class="card">
            <h3 class="card-header" style="margin-top: 0px;">Troubleshooting</h3>
            <ul class="list-group">
                <li class="list-group-item">
                    <clr-signpost>
                        <button class="btn btn-sm btn-primary" clrSignpostTrigger (click)="openAnonymisedUiDataSignpost()">Download UI data</button>
                        <clr-signpost-content #anonymisedUiDataSignpost [clrPosition]="'right-middle'" *clrIfOpen>
                            <clr-signpost-title>Protect the UI data archive</clr-signpost-title>
                            <p>
                                The archive is encrypted with the password you choose here. Give that password to
                                Easyvirt's team, along with the archive, so that they can open it.
                            </p>
                            <form clrForm clrLayout="vertical" (ngSubmit)="downloadAnonymisedUiData()">
                                <clr-password-container>
                                    <label>Password</label>
                                    <input clrPassword type="password" name="anonymisedUiDataPassword"
                                           autocomplete="new-password"
                                           [(ngModel)]="anonymisedUiDataPassword"/>
                                </clr-password-container>
                                <clr-alert *ngIf="anonymisedUiDataErrorMessage !== undefined" [clrAlertType]="'danger'"
                                           [clrAlertClosable]="false" [clrAlertSizeSmall]="true">
                                    <clr-alert-item>
                                        <span class="alert-text">{{ anonymisedUiDataErrorMessage }}</span>
                                    </clr-alert-item>
                                </clr-alert>
                                <button class="btn btn-sm btn-primary" type="submit" style="margin-top: 12px;"
                                        [disabled]="anonymisedUiDataIsDownloading">Download</button>
                                <span *ngIf="anonymisedUiDataIsDownloading" class="spinner spinner-inline"></span>
                            </form>
                        </clr-signpost-content>
                    </clr-signpost>
                    Download the currently displayed UI data (anonymised) to help Easyvirt's team to reproduce what you see.
                </li>
            </ul>
        </div>


    </div>
</div>
